import React, { useState } from 'react';
import { Key, Shield, ListChecks } from 'lucide-react';
import { ToastContainer, useToast } from '../../components/shared/Toast';
import {
  PasswordSecurityTab,
  TwoFactorAuthTab,
} from '../../components/vendor/profile';
import { VendorPageHeader, VendorGuideCallout } from '../../components/vendor/guidance';
import { VENDOR_PAGE_GUIDES } from '../../utils/vendorPageGuides';

const VendorSecurity = () => {
  const toast = useToast();
  const [activeTab, setActiveTab] = useState('password');

  const tabs = [
    { id: 'password', name: 'Password & Security', icon: Key },
    { id: 'twofactor', name: 'Two-Factor Auth', icon: Shield },
  ];

  return (
    <div className="space-y-5">
      <VendorPageHeader
        title="Security"
        subtitle="Update your password and enable two-factor authentication to protect your account."
      />

      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.security.title}
        steps={VENDOR_PAGE_GUIDES.security.steps}
        icon={ListChecks}
      />

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm overflow-hidden">
        <div className="border-b border-gray-200 dark:border-gray-800 px-4 py-3 sm:px-5 overflow-x-auto">
          <div
            className="inline-flex flex-wrap rounded-xl bg-gray-100 dark:bg-gray-800 p-1 border border-gray-200/80 dark:border-gray-700 min-w-max"
            role="tablist"
            aria-label="Security sections"
          >
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveTab(tab.id)}
                  className={`inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-3.5 py-2 rounded-lg text-xs sm:text-sm font-medium whitespace-nowrap transition-all ${
                    isActive
                      ? 'bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-50 shadow-sm'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                  }`}
                >
                  <Icon className="w-4 h-4 flex-shrink-0" />
                  <span>{tab.name}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="p-4 sm:p-6 lg:p-8">
          {activeTab === 'password' && <PasswordSecurityTab />}
          {activeTab === 'twofactor' && <TwoFactorAuthTab />}
        </div>
      </div>

      <ToastContainer toasts={toast.toasts} position="top-right" onRemove={toast.removeToast} />
    </div>
  );
};

export default VendorSecurity;
